import { AnimatedShield } from "./AnimatedShield";

interface BrandLoaderProps {
  label?: string;
  fullPage?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZES = {
  sm: "w-12 h-12",
  md: "w-20 h-20",
  lg: "w-28 h-28",
};

export function BrandLoader({
  label = "Loading…",
  fullPage = false,
  size = "md",
  className = "",
}: BrandLoaderProps) {
  const content = (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div className={SIZES[size]}>
        <AnimatedShield beat="power-on" />
      </div>
      {label && (
        <div
          className="font-mono text-[11px] tracking-[0.2em] uppercase text-[hsl(var(--brand-slate))]"
          role="status"
          aria-live="polite"
        >
          {label}
        </div>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-[60vh] w-full flex items-center justify-center bg-[hsl(var(--brand-bone))]">
        {content}
      </div>
    );
  }

  return <div className="w-full py-12 flex items-center justify-center">{content}</div>;
}
